import { Tooltip } from '@mui/material';
import DeviceActions from '../actions/devices-actions';
import { statusOptionsForOs, SelectionMode } from '@shared/models/table.model';
import { getSelectColumn } from '@utils/table-selection.utils.tsx';
import { formatDate } from '@utils/date-format-utils.ts';
import {
  DeviceColumnsParams,
  DevicesRowDataProps
} from '@modules/digital-signage/model/devices.model.ts';

export const deviceColumns = ({
  reloadDevice,
  handleGroupSettings,
  handleDelete,
  handleMoveToGroup,
  handleSelectRow,
  handleSelectAll,
  isPageAllSelected,
  isPagePartiallySelected,
  isRowSelected,
  deviceGroupsData
}: DeviceColumnsParams) => [
  getSelectColumn<DevicesRowDataProps>({
    handleSelectRow,
    handleSelectAll,
    isPageAllSelected,
    isPagePartiallySelected,
    isRowSelected
  }),
  {
    id: 'name',
    label: 'column_label_name',
    field: 'name',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'deviceId',
    label: 'column_label_device_id',
    field: 'deviceId',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value ?? 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'os',
    label: 'column_label_os',
    field: 'os',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: false,
    showFilter: true,
    selectionMode: SelectionMode.Multiple,
    filterData: statusOptionsForOs,
    isTranslated: false
  },
  {
    id: 'model',
    label: 'column_label_model',
    field: 'model',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'deviceGroup.name',
    label: 'column_label_device_group',
    field: 'deviceGroup',
    render: (value: any) => (
      <Tooltip title={value?.name || 'N/A'} followCursor>
        <span>{value?.name || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: false,
    showFilter: true,
    selectionMode: SelectionMode.Single,
    filterData: deviceGroupsData,
    showSearchInput: true,
    isTranslated: false
  },
  {
    id: 'ip',
    label: 'column_label_ip',
    field: 'ip',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'createdAt',
    label: 'column_label_createdAt',
    field: 'createdAt',
    render: (value: any) => (
      <Tooltip title={value ? formatDate(value) : '-'} followCursor>
        <span>{value ? formatDate(value) : '-'}</span>
      </Tooltip>
    ),
    showSort: true,
    showSearch: false,
    showFilter: false
  },
  // {
  //   id: 'type',
  //   label: 'column_label_type',
  //   field: 'type',
  //   render: (value: any) => (
  //     <Tooltip title={value} followCursor>
  //       <span>{value}</span>
  //     </Tooltip>
  //   ),
  //   showSort: false,
  //   showSearch: false,
  //   showFilter: true,
  //   filterData: statusOptionsForDeviceType,
  //   isTranslated: false
  // },
  {
    id: 'Action',
    label: 'column_label_actions',
    field: 'actions',
    render: (value: any, row: DevicesRowDataProps) => (
      <DeviceActions
        row={row}
        reloadDevice={reloadDevice}
        handleDelete={handleDelete}
        handleGroupSettings={handleGroupSettings}
        handleMoveToGroup={handleMoveToGroup}
      />
    ),
    showSort: false,
    showSearch: false,
    showFilter: false
  }
];
